import { render } from "./LaborersAttendanceOtherData.vue?vue&type=template&id=ed2a2aa4&scoped=true"
import script from "./LaborersAttendanceOtherData.vue?vue&type=script&lang=js"
export * from "./LaborersAttendanceOtherData.vue?vue&type=script&lang=js"

import "./LaborersAttendanceOtherData.vue?vue&type=style&index=0&id=ed2a2aa4&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed2a2aa4"],['__file',"src/views/h5/luqiao/laborers/attendance/result/LaborersAttendanceOtherData.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ed2a2aa4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ed2a2aa4', __exports__)) {
    api.reload('ed2a2aa4', __exports__)
  }
  
  module.hot.accept("./LaborersAttendanceOtherData.vue?vue&type=template&id=ed2a2aa4&scoped=true", () => {
    api.rerender('ed2a2aa4', render)
  })

}


export default __exports__